// extracted by mini-css-extract-plugin
export var box = "_3s-1";
export var checkboxRow = "_3s-8";
export var checked = "_3s-2";
export var descriptionSpacer = "_3s-a";
export var disabled = "_3s-3";
export var icon = "_3s-6";
export var input = "_3s-0";
export var labelSpacer = "_3s-9";
export var medium = "_3s-5";
export var small = "_3s-4";
export var text = "_3s-7";